import React from "react"

function AlignRight({ size }) {
    return <svg viewBox="0 0 24 24" height={size}><path d="M20 2h2v20h-2V2zM2 10h16V7H2v3zm6 7h10v-3H8v3z"></path></svg>
}

export default AlignRight